var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.inputFields),function(field){return _c('b-col',{key:field.key,attrs:{"md":"6","cols":"12"}},[_c('prozess-input',{attrs:{"placeholder":_vm.$t(field.label),"field":field.key,"name":field.key},model:{value:(field.val),callback:function ($$v) {_vm.$set(field, "val", $$v)},expression:"field.val"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }